import React, { useEffect, useState } from "react";
import axios from "axios";
import Title from "../components/Layout/Title";
import { useParams } from "react-router";
import ProductCards from "../components/ProductCards";
import Loading from "../components/Loading/index";

export default function CategoriaProducts() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [categoria, setCategoria] = useState({});

    useEffect(() => {
        axios
            .get(`https://shoppi-test.herokuapp.com/api/get/categoria?categoria=${id}`)
            .then((res) => {
                setCategoria(res.data);
                setLoading(true);
            });
    }, [id]);

    return (
        <>
            {loading ? (
                <>
                    <Title key={categoria._id}>
                        Products of {categoria.name}
                    </Title>
                    <ProductCards product={categoria.product} />
                </>
            ) : (
                <Loading text={"Loading Categorias"} />
            )}
        </>
    );
}
